import { render, staticRenderFns } from "./ManteCartaKit.vue?vue&type=template&id=500133d9&"
import script from "./ManteCartaKit.vue?vue&type=script&lang=js&"
export * from "./ManteCartaKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports